<div [ngClass]="loading ? 'lock' : ''">
  <div class="table-container panel">
    <div class="example-table-container">
      <div
        *ngIf="loading"
        class="table-loader-overlay"
        style="margin-top: 55px"
      >
        <div style="margin-top: 145px; align-self: center">
          <mat-spinner
            style="margin: auto"
            color="primary"
            diameter="75"
          ></mat-spinner>
        </div>
      </div>
      <table mat-table [dataSource]="items" class="example-table" matSort>
        <ng-container matColumnDef="projectId">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>#</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('project__id')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="copyProjectId(row)"
          >
            <span>{{ row.project?.id }}</span>
            <span
              *ngIf="row.project?.oldPlatformId != null"
              class="font-weight-bold font-italic"
              [matTooltip]="'Jobnummer oud platform'"
            >
              ({{ row.project.oldPlatformId }})</span
            >
          </td>
        </ng-container>

        <ng-container matColumnDef="placementDate">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Toer datum</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.currentConfirmedPlacementDateDisplay }}
          </td>
        </ng-container>

        <ng-container matColumnDef="installer">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Instal.</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            [matTooltip]="
              row.tourItem?.tour?.placer?.user?.firstName
                | personName : row.tourItem?.tour?.placer?.user?.lastName
            "
            (click)="openProject(row)"
          >
            <div
              *ngIf="row.tourItem?.tour != null"
              class="employee-initials-requestor rounded-circle in-the-middle placer-margin"
            >
              <span
                style="margin-top: 2px"
                *ngIf="!row.tourItem?.tour?.placer?.user?.profilePicture"
              >
                {{
                  row.tourItem?.tour?.placer?.user?.firstName
                    | initials : row.tourItem?.tour?.placer?.user?.lastName
                }}</span
              >
              <span *ngIf="row.tourItem?.tour?.placer?.user?.profilePicture">
                <img
                  style="margin-top: 2px"
                  class="rounded-circle"
                  width="30px"
                  height="30px"
                  [src]="
                    '/api/assets/' +
                    row.tourItem?.tour?.placer?.user?.profilePicture.uuid +
                    '/30'
                  "
                />
              </span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="branch">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Filiaal</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text padding-right"
            (click)="openProject(row)"
          >
            {{ row.tourItem?.tour?.placer?.branch?.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Klantnaam</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('immoNewCustomerName')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.project?.companyNamesDisplay }}
          </td>
        </ng-container>

        <ng-container matColumnDef="designInfo">
          <th mat-header-cell *matHeaderCellDef class="header-text"></th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <div
              *ngIf="row.project?.firstIpBoard?.generalExtraInfo?.length > 0"
              class="circle circle--red"
              [matTooltip]="row.project?.firstIpBoard?.generalExtraInfo"
            ></div>
          </td>
        </ng-container>

        <ng-container matColumnDef="customText">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Gepersonaliseerde tekst</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <div class="text-container">
              <label (click)="openProject(row)">{{
                row.project?.firstIpBoard?.customText
              }}</label>
              <mat-icon
                (click)="copyToClipboard(row.project?.firstIpBoard?.customText)"
                matTooltip="Kopiëren"
                >content_copy</mat-icon
              >
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="textAmount">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Aantal</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.project?.firstIpBoard.amount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="kind">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Soort</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.project?.firstIpBoard?.kind }}
          </td>
        </ng-container>

        <ng-container matColumnDef="measurements">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Afm</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            [matTooltip]="row.project?.firstIpBoard?.measurements"
            (click)="openProject(row)"
          >
            {{ row.project?.firstIpBoard?.measurements | shortenText }}
          </td>
        </ng-container>

        <ng-container matColumnDef="textType">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Type</b>
              </div>
            </div>
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            {{ row.project?.firstIpBoard?.textTypeDisplay }}
          </td>
        </ng-container>

        <ng-container matColumnDef="design">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b>Design</b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <ng-container
              *ngIf="
                row.project?.firstIpBoard &&
                row.project?.firstIpBoard.design &&
                (row.type
                  | overviewProjectType
                    : row.status
                    : row.withPlacement
                    : null) !== 'Aanpassing'
              "
            >
              <img
                [ngClass]="first ? '' : 'hidden'"
                width="30px"
                height="30px"
                [src]="
                  '/api/assets/' + row.project?.firstIpBoard.design.uuid + '/30'
                "
                (click)="openLightbox(row.project?.firstIpBoard.design)"
              />
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="displayStatus">
          <th mat-header-cell *matHeaderCellDef class="header-text"></th>
          <td
            mat-cell
            *matCellDef="let row"
            class="table-text"
            (click)="openProject(row)"
          >
            <span
              [ngClass]="
                row.type
                  | overviewProjectTypeClass
                    : row.status
                    : row.withPlacement
                    : null
                    : subProjectTypeRightMargin
              "
              class="clickable status"
              (click)="navigateTab(row.id, row.project.id, row.displayStatus)"
            >
              {{
                row.type
                  | overviewProjectType : row.status : row.withPlacement : null
              }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="markAsDoneAction">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle">
                <b></b>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            <div class="action-container">
              <mat-checkbox
                [(ngModel)]="row.project?.firstIpBoard.markedAsDone"
              >
              </mat-checkbox>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="groupHeader">
          <td mat-cell *matCellDef="let groupBy" colspan="14">
            {{ groupBy.header }}
          </td>
        </ng-container>

        <ng-container matColumnDef="emptyRow">
          <td mat-cell *matCellDef="let empty">-</td>
        </ng-container>

        <ng-container matColumnDef="dividerRow">
          <td mat-cell *matCellDef="let empty" colspan="14"></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <tr
          mat-row
          class="table-row"
          *matRowDef="let row; columns: displayedColumns; when: isItem"
          [ngClass]="row.statusClass"
        ></tr>

        <tr
          mat-row
          class="table-row"
          *matRowDef="let row; columns: ['groupHeader']; when: isGroup"
          [ngClass]="row.rowClass"
        ></tr>

        <tr
          mat-row
          class="table-row"
          *matRowDef="let row; columns: ['emptyRow']; when: isEmpty"
        ></tr>

        <tr
          mat-row
          class="divider-row"
          *matRowDef="let row; columns: ['dividerRow']; when: isDivider"
        ></tr>
      </table>
    </div>

    <mat-paginator
      [length]="totalItems"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="true"
      (page)="onPageChange()"
    ></mat-paginator>
  </div>

  <ng-container>
    <div class="save-container">
      <button class="btn button" type="button" (click)="save()">
        <span>Opslaan</span>
      </button>
    </div>
  </ng-container>
</div>
